import {
  ACT_COUNTRIES_FETCH_INIT,
  ACT_COUNTRIES_FETCH_200,
  ACT_COUNTRIES_ADD_INIT,
  ACT_COUNTRIES_ADD_201,
  ACT_COUNTRIES_DELETE_INIT,
  ACT_COUNTRIES_DELETE_204,
  ACT_COUNTRIES_ADD_500,
} from '../constants/actions';

export const fetchCountriesAction = () => ({
  type: ACT_COUNTRIES_FETCH_INIT,
});

export const fetchCountriesSuccessAction = data => ({
  type: ACT_COUNTRIES_FETCH_200,
  payload: data,
});

export const addCountryInitAction = data => ({
  type: ACT_COUNTRIES_ADD_INIT,
  payload: data,
});

export const addCountryFailAction = data => ({
  type: ACT_COUNTRIES_ADD_500,
  payload: data,
});

export const addCountrySuccessAction = data => ({
  type: ACT_COUNTRIES_ADD_201,
  payload: data,
});

export const deleteCountryInitAction = data => ({
  type: ACT_COUNTRIES_DELETE_INIT,
  payload: data,
});

export const deleteCountrySuccessAction = () => ({
  type: ACT_COUNTRIES_DELETE_204,
});
